// extracted by mini-css-extract-plugin
export var table = "_wf-0";